/* OXXRING v2 quick order: paste many sizes, match exact listings, add direct-buy lines to the cart.
   Buyability and prices come from the server (sections/oxx-ic-qo-data.liquid); nearby sizes are never substituted. */
(function () {
  'use strict';
  var MAX_LINES = 40;

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var dataCache = {};
  function qoData(handle) {
    if (!dataCache[handle]) {
      dataCache[handle] = fetch('/products/' + handle + '?section_id=oxx-ic-qo-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { var t = document.createElement('template'); t.innerHTML = html; var s = t.content.querySelector('[data-qo]'); return s ? JSON.parse(s.textContent) : null; })
        .catch(function () { return null; });
    }
    return dataCache[handle];
  }

  function parseLine(raw, X) {
    var line = raw.trim();
    var p = { raw: line, qty: null };
    var sku = line.toUpperCase().match(/OXX-OR-(\d+)P(\d+)-(\d+)P(\d+)-([A-Z]+)-(\d{2})A/);
    if (sku) {
      p.id = parseFloat(sku[1] + '.' + sku[2]); p.cs = parseFloat(sku[3] + '.' + sku[4]);
      p.mat = { NBR: 'N', FKM: 'F', FFKM: 'K', EPDM: 'E', SILICONE: 'S' }[sku[5]] || ''; p.hard = sku[6];
      line = line.replace(sku[0], ' ');
    } else {
      var b = X.parse(line);
      p.id = b.id; p.cs = b.cs; p.dash = b.dash; p.mat = b.mat || ''; p.hard = b.hard || ''; p.unit = b.unit;
    }
    // Remove the size itself first so "30 x 3" is never read as a quantity of 3.
    var noSize = line.replace(/(\d+(?:[.,]\d+)?)\s*(?:mm|in|inch|")?\s*[x×*]\s*(\d+(?:[.,]\d+)?)\s*(?:mm|in|inch|")?/i, ' ')
      .replace(/\bas\s*-?\s*568\s*[-#]?\s*\d{1,3}\b|(?:^|\s)[-#]\d{3}\b/i, ' ');
    var q = noSize.match(/(\d[\d,]*)\s*(?:pcs|pieces|piece|pc|ea|each)\b/i) || noSize.match(/\b(?:qty|quantity|q)\s*[:=]?\s*(\d[\d,]*)\b/i) || noSize.match(/[x×*]\s*(\d[\d,]*)\s*$/i);
    if (q) p.qty = parseInt(q[1].replace(/,/g, ''), 10) || null;
    // Bare numbers after the size, e.g. "20x2.5 NBR 70 100" or "-214 FKM 50": with two numbers the first is the
    // hardness and the last the quantity; a single number is the hardness only when it is a common grade (60-90)
    // and a material is named, otherwise it is the quantity. Hardness written as "70A" / "Shore 70" is parsed above.
    var rest = (q ? noSize.replace(q[0], ' ') : noSize)
      .replace(/\b\d{2}\s*(?:a\b|sh(?:ore)?\s*a?\b|duro)/ig, ' ').replace(/\bshore\s*a?\s*\d{2}\b/ig, ' ');
    var nums = (rest.match(/(?:^|\s)\d[\d,]*(?=\s|$)/g) || []).map(function (s) { return parseInt(s.replace(/[\s,]/g, ''), 10); }).filter(function (n) { return n > 0; });
    var HARD = [50, 60, 70, 75, 80, 90], COMMON = [60, 70, 75, 80, 90];
    if (!p.hard && nums.length && HARD.indexOf(nums[0]) > -1 && (nums.length >= 2 || p.qty || (p.mat && COMMON.indexOf(nums[0]) > -1))) p.hard = String(nums.shift());
    if (!p.qty && nums.length) p.qty = nums[nums.length - 1];
    return p;
  }

  function plan(variants, qty) {
    var ok = variants.filter(function (v) { return v.available && v.pack > 0 && v.price > 0; });
    if (!ok.length) return null;
    if (!qty) { ok.sort(function (a, b) { return a.pack - b.pack; }); return { v: ok[0], packs: 1 }; }
    var best = null;
    ok.forEach(function (v) {
      var packs = Math.ceil(qty / v.pack), cost = packs * v.price, surplus = packs * v.pack - qty;
      if (!best || cost < best.cost || (cost === best.cost && surplus < best.surplus)) best = { v: v, packs: packs, cost: cost, surplus: surplus };
    });
    return best;
  }

  function init(root) {
    var X = window.OXXIC; if (!X || root.dataset.icReady) return; root.dataset.icReady = '1';
    var form = root.querySelector('[data-ic-qo-form]'), text = root.querySelector('[data-ic-qo-text]');
    var out = root.querySelector('[data-ic-qo-out]'), tbody = root.querySelector('[data-ic-qo-rows]');
    var sum = root.querySelector('[data-ic-qo-sum]'), addBtn = root.querySelector('[data-ic-qo-add]');
    var rfqBtn = root.querySelector('[data-ic-qo-rfq]'), msg = root.querySelector('[data-ic-qo-msg]');
    var lines = [];

    try { var saved = sessionStorage.getItem('oxx-qo-text'); if (saved && !text.value) text.value = saved; } catch (e) {}
    root.querySelector('[data-ic-qo-clear]').addEventListener('click', function () { text.value = ''; out.hidden = true; lines = []; try { sessionStorage.removeItem('oxx-qo-text'); } catch (e) {} });

    // Load a CSV / TXT parts list into the textarea (commas, semicolons and tabs become spaces).
    var loader = root.querySelector('[data-ic-qo-load]'), loadMsg = root.querySelector('[data-ic-qo-loadmsg]');
    if (loader && window.FileReader) loader.addEventListener('change', function () {
      var file = loader.files && loader.files[0]; loader.value = '';
      if (!file) return;
      var say = function (t, err) { loadMsg.hidden = false; loadMsg.textContent = t; loadMsg.classList.toggle('is-err', !!err); };
      if (!/\.(csv|txt)$/i.test(file.name) || file.size > 200000) { say('Use a .csv or .txt file under 200 KB.', true); return; }
      var reader = new FileReader();
      reader.onload = function () {
        var rows = String(reader.result || '').split(/\r?\n/).map(function (r) { return r.replace(/["']/g, '').replace(/[,;\t]+/g, ' ').replace(/\s+/g, ' ').trim(); })
          .filter(function (r) { return r && !/^(size|id|part|item)\b/i.test(r); }).slice(0, MAX_LINES);
        if (!rows.length) { say('No lines found in ' + file.name + '.', true); return; }
        text.value = rows.join('\n');
        say(rows.length + ' line' + (rows.length > 1 ? 's' : '') + ' loaded from ' + file.name + '. Check them, then press Check lines.');
        text.focus();
      };
      reader.onerror = function () { say('Could not read ' + file.name + '.', true); };
      reader.readAsText(file);
    });

    function refresh() {
      var total = 0, n = 0, other = [];
      lines.forEach(function (L) {
        if (L.state === 'ok') { total += L.pick.v.price * L.pick.packs; n++; }
        else other.push(L.raw + '  →  ' + L.reason);
      });
      sum.textContent = n ? n + ' line' + (n > 1 ? 's' : '') + ' ready · ' + money(total) + ' before tax and shipping' : 'No line is ready for the cart yet';
      addBtn.disabled = !n;
      if (other.length) {
        var ctx = ('Quick order request:\n' + other.join('\n')).slice(0, 1500);
        rfqBtn.href = '/pages/bulk-quote?source=quick-order&request_mode=BULK&context=' + encodeURIComponent(ctx);
        rfqBtn.hidden = false; rfqBtn.textContent = 'Send ' + other.length + ' other line' + (other.length > 1 ? 's' : '') + ' as a request';
      } else rfqBtn.hidden = true;
    }

    function renderRow(L) {
      var tr = L.tr || el('tr'); L.tr = tr; tr.replaceChildren();
      tr.appendChild(el('td', 'ic-mono ic-qo__raw', L.raw));
      var match = el('td'), packsTd = el('td'), piecesTd = el('td', 'ic-num'), totalTd = el('td', 'ic-num'), statusTd = el('td');
      if (L.size) match.appendChild(el('div', 'ic-num', L.size));
      if (L.choices) {
        var sel = el('select', 'ic-select'); sel.setAttribute('aria-label', 'Choose material and hardness for ' + L.raw);
        sel.appendChild(new Option('Choose material / hardness', ''));
        L.choices.forEach(function (c) { sel.appendChild(new Option(X.MAT[c.m][0] + ' ' + c.h + 'A', c.m + c.h)); });
        sel.addEventListener('change', function () { if (!sel.value) return; L.mat = sel.value[0]; L.hard = sel.value.slice(1); resolve(L); });
        match.appendChild(sel);
      } else if (L.data) {
        var a = el('a', 'ic-link', L.data.title); a.href = L.data.url; a.target = '_blank'; match.appendChild(a);
      }
      if (L.state === 'ok') {
        var ps = el('select', 'ic-select ic-qo__pack'); ps.setAttribute('aria-label', 'Pack size');
        L.data.variants.filter(function (v) { return v.available && v.pack > 0 && v.price > 0; }).sort(function (a, b) { return a.pack - b.pack; })
          .forEach(function (v) { var o = new Option(v.pack + ' pcs · ' + money(v.price), v.id); if (v.id === L.pick.v.id) o.selected = true; ps.appendChild(o); });
        var num = el('input', 'ic-input ic-input--num ic-qo__num'); num.type = 'number'; num.min = 1; num.value = L.pick.packs; num.setAttribute('aria-label', 'Number of packs');
        var upd = function () {
          var v = L.data.variants.filter(function (x) { return String(x.id) === ps.value; })[0];
          L.pick = { v: v, packs: Math.max(1, parseInt(num.value, 10) || 1) }; renderRow(L); refresh();
        };
        ps.addEventListener('change', upd); num.addEventListener('change', upd);
        var wrap = el('div', 'ic-qo__packs'); wrap.appendChild(num); wrap.appendChild(el('span', 'ic-note', '×')); wrap.appendChild(ps); packsTd.appendChild(wrap);
        var pcs = L.pick.v.pack * L.pick.packs;
        piecesTd.textContent = pcs.toLocaleString('en-US') + (L.qty && L.qty !== pcs ? ' (need ' + L.qty.toLocaleString('en-US') + ')' : '');
        totalTd.textContent = money(L.pick.v.price * L.pick.packs);
        statusTd.appendChild(el('span', 'ic-route ic-route--DIRECT_BUY', 'Ready'));
      } else {
        packsTd.textContent = '—'; piecesTd.textContent = L.qty ? L.qty.toLocaleString('en-US') : '—'; totalTd.textContent = '—';
        var cls = L.state === 'quote' ? 'QUOTE_REQUIRED' : L.state === 'choose' ? 'CHECK_AVAILABILITY' : L.state === 'loading' ? 'CHECK_AVAILABILITY' : 'CUSTOM';
        var badge = el('span', 'ic-route ic-route--' + cls, L.label || L.reason); statusTd.appendChild(badge);
      }
      tr.append(match, packsTd, piecesTd, totalTd, statusTd);
      // Labels for the stacked mobile cards; empty cells are hidden there.
      ['Your line', 'Match', 'Packs', 'Pieces', 'Total', 'Status'].forEach(function (label, i) {
        var td = tr.children[i]; if (!td) return;
        td.setAttribute('data-label', label);
        td.classList.toggle('is-empty', !td.textContent.trim() || td.textContent.trim() === '—');
      });
      if (!tr.parentNode) tbody.appendChild(tr);
    }

    function resolve(L) {
      L.choices = null; L.data = null;
      X.sizeIndex(root.dataset.indexUrl).then(function (index) {
        var rows = X.exact(index, L.id, L.cs);
        L.size = L.id.toFixed(2) + ' × ' + L.cs.toFixed(2) + ' mm';
        if (!rows.length) { L.state = 'none'; L.reason = 'size not listed'; L.label = 'Not listed'; renderRow(L); refresh(); return; }
        var codes = rows[0].codes.filter(function (c) { return (!L.mat || c.m === L.mat) && (!L.hard || c.h === L.hard); });
        if (codes.length !== 1) {
          L.state = 'choose'; L.reason = codes.length ? 'material / hardness to confirm' : 'requested grade not listed at this size'; L.label = codes.length ? 'Choose grade' : 'Grade not listed';
          L.choices = codes.length ? codes : rows[0].codes; renderRow(L); refresh(); return;
        }
        L.state = 'loading'; L.label = 'Checking…'; L.reason = 'not checked'; renderRow(L);
        qoData(X.handleFor(index, rows[0], codes[0])).then(function (d) {
          if (!d) { L.state = 'none'; L.reason = 'listing unavailable'; L.label = 'Unavailable'; }
          else if (d.route !== 'DIRECT_BUY') { L.data = d; L.state = 'quote'; L.reason = 'quoted on request (' + d.title + ')'; L.label = 'Quote required'; }
          else {
            L.data = d; L.pick = plan(d.variants, L.qty);
            if (L.pick) L.state = 'ok'; else { L.state = 'quote'; L.reason = 'no priced pack (' + d.title + ')'; L.label = 'Price on request'; }
          }
          renderRow(L); refresh();
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      try { sessionStorage.setItem('oxx-qo-text', text.value); } catch (er) {}
      var raw = text.value.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, MAX_LINES);
      tbody.replaceChildren(); lines = []; out.hidden = !raw.length; msg.hidden = true;
      if (!raw.length) return;
      var needAs = raw.some(function (r) { return /as\s*-?568|^-?\d{3}\b/i.test(r); });
      (needAs ? X.loadJSON(root.dataset.as568Url) : Promise.resolve(null)).then(function (as568) {
        raw.forEach(function (r) {
          var L = parseLine(r, X); lines.push(L);
          if (!L.id && L.dash && as568) { var row = as568.rows.filter(function (x) { return x.d === L.dash; })[0]; if (row) { L.id = row.im; L.cs = row.cm; } }
          if (!L.id || !L.cs) { L.state = 'none'; L.reason = 'size not recognised'; L.label = 'Not recognised'; renderRow(L); return; }
          resolve(L);
        });
        refresh();
        window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'oxx_quick_order_check', line_count: raw.length });
      });
    });

    addBtn.addEventListener('click', function () {
      var items = lines.filter(function (L) { return L.state === 'ok'; }).map(function (L) { return { id: L.pick.v.id, quantity: L.pick.packs }; });
      if (!items.length) return;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () {
          msg.hidden = false; msg.className = 'ic-buy__msg ic-buy__msg--ok';
          msg.innerHTML = items.length + ' line' + (items.length > 1 ? 's' : '') + ' added. <a class="ic-link" href="/cart">View cart and check out →</a>';
          document.dispatchEvent(new CustomEvent('oxx:cart:changed'));
        })
        .catch(function (err) { msg.hidden = false; msg.className = 'ic-buy__msg ic-buy__msg--err'; msg.textContent = err.message; })
        .then(function () { addBtn.disabled = false; addBtn.textContent = 'Add matched lines to cart'; });
    });
  }

  function boot() { document.querySelectorAll('[data-ic-qo]').forEach(init); }
  if (window.OXXIC) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
